export default "__VITE_ASSET__Wvh8$506__"